<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditDeuMatchDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <DeuMatchDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import DeuMatchDataTable from "../../components/shared/datatables/DeuMatchDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/deuMatch";
import CreateEditDeuMatchDialog from "../../components/shared/dialogs/CreateEditDeuMatchDialog";
import {ApiError} from "../../api/core";
import {mapActions,mapGetters} from "vuex";
//PKs
import {findAll as findAllComprador} from "../../api/comprador";
import {findAll as findAllFornecedor} from "../../api/fornecedor";
import {findAll as findAllOferta} from "../../api/oferta";

export default {
  name: "index",
  components: {CreateEditDeuMatchDialog, BaseView, DeuMatchDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Comprador',
          column: 'idComprador',
          type: 'autocomplete',
          optionsFactory: (search) => findAllComprador(1,{
            nome: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.nomeCompleto
                }))
              })
        }, 
        {
          name: 'Fornecedor',
          column: 'idFornecedor',
          type: 'autocomplete',
          optionsFactory: (search) => findAllFornecedor(1,{
            nome: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.nomeCompleto
                }))
              })
        }, 
        {
          name: 'Item Demandado',
          column: 'idOferta',
          type: 'autocomplete',
          optionsFactory: (search) => findAllOferta(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },         
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Match. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Match removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {        
          this.$toast.error(`Não foi possível remover o Match.`, {
            timeout: 6000
          })
        }  
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.permiteCadastrar = false;
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>